import React, { useState } from 'react';
import { ProgramCostStyles } from './ProgramCostStyles';
import { IProgramCost } from '../../enteties/IProgramCost';
import { InView } from 'react-intersection-observer';
import ContactForm from '../contactForm/ContactForm';
import Modal from '../modal/Modal';
import ShowTextByLetter from '../../utils/ShowTextByLetter/ShowTextByLetter';
import getTranslationByLangOrUk from '../../utils/getTranslationByLangOrUk';
import { useAppSelector } from '../../state/hooks';

interface Props extends IProgramCost {
  emailDescription: string;
}

function ProgramCost({
  emailDescription, description, headListData, courseOptions, caption = true, otherCurrencyText = false, subdescription,
}: Props) {
  const [modalActive, setModalActive] = useState<boolean>(false);
  const [indexOfSelectedItem, setIndexOfSelectedItem] = useState<number>(0);

  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <ProgramCostStyles className="programCost">
      {modalActive && (
        <Modal onClose={() => setModalActive(false)}>
          <ContactForm
            emailDescription={`${emailDescription} - ${courseOptions[indexOfSelectedItem].title}`}
            withoutTitle
            inModal
          />
        </Modal>
      )}

      <div className="container">
        <div className="head">
          <h2>{ShowTextByLetter(getTranslationByLangOrUk(interfaceLanguage, 'program_cost_title'))}</h2>

          <div className="listWrapper">
            {caption && <span className="caption">{ShowTextByLetter(getTranslationByLangOrUk(interfaceLanguage, 'program_cost_subtitle'))}</span>}

            {headListData && (
              <ul>
                {headListData.map((text) => (
                  <InView key={text} threshold={0.2} as="li" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
                    <span>{text}</span>
                  </InView>
                ))}
              </ul>
            )}

            <div className="descriptionWrapper">
              {description && (
                <InView threshold={0.2} as="p" className="description" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
                  {description}
                </InView>
              )}
              {subdescription && (
                <InView className="subdescription textBase18 textBold" threshold={0.2} as="p" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
                  {subdescription}
                </InView>
              )}
            </div>
          </div>
        </div>

        <ul className="list">
          {courseOptions.map((item, index) => (
            <InView key={item.title} className={`listItem item${index + 1}`} threshold={0.5} as="li" onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
              <div className="contentWrapper">
                <div className="itemHead">
                  <div>
                    <h3>{item.title}</h3>

                    <ul>
                      {item.listData.map((text) => (
                        <li key={text}>
                          <span>{text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <span className="price">
                    {item.price}
                    {!otherCurrencyText && (
                      <>
                        {' '}
                        {getTranslationByLangOrUk(interfaceLanguage, 'uah').toUpperCase()}
                      </>
                    )}

                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setIndexOfSelectedItem(index);

                    setModalActive(true);
                  }}
                  className="button"
                >
                  {getTranslationByLangOrUk(interfaceLanguage, 'gift_sertificates_8')}
                </button>
              </div>
            </InView>
          ))}
        </ul>

      </div>
    </ProgramCostStyles>
  );
}

export default ProgramCost;
